import * as React from "react";
import { PostCodeAnywhereSearchEditor } from "../../../../../../../react-core/Html/Address/PostCodeAnywhereSearchEditor";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { AddressDisplay } from "../../../../../../../react-core/Html/Address/AddressDisplay";
import { AddressDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { PhysicalAddressType } from "../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { AddressEditorFields } from "../../../../../../../react-core/Html/Address/AddressEditorFields";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { CountryCodeMap } from "../../../../../../Shared/Entities/Maps/CountryCodeMap";
import { SectionHeader } from "../SharedComponents";

interface IAddAddressProps extends IProcessComponentProps {
    address: AddressDetailModel;
    onAddressChange: (v) => void;
    label: string;
    index: number;
    onCCMChange: (changes) => void;
    addressType: PhysicalAddressType;
    addressList: Array<AddressDetailModel>;
    resetUseAddressForCorrespondence?: () => void;
    disabled: boolean;
    canChooseCountry: boolean;
}

interface IAddAddressState {
    isEditManual: boolean;
}

export class AddAddress extends ProcessComponent<IAddAddressProps, IAddAddressState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isEditManual: false,
        };
    }

    isValid() {
        return super.isValid();
    }

    render() {
        const { address, index, resetUseAddressForCorrespondence, onCCMChange, disabled } = this.props;
        if (disabled) {
            return (
                <div className="mb-24">
                    <AddressDisplay address={address} />
                </div>
            );
        }
        return (
            <>
                {this.props.canChooseCountry && (
                    <>
                        {SectionHeader(this.props.label)}
                        <div className="row">
                            <div className="col-fluid col-max-430">
                                <SelectEditor
                                    placeholder="Please select"
                                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                                    getText={(v) => CountryCodeMap.getString(v)}
                                    label="Country"
                                    onChange={(v) => {
                                        onCCMChange([
                                            {
                                                value: this.props.addressType,
                                                path: `AddressDetails.${index}.PhysicalAddressType`,
                                            },
                                            {
                                                value: null,
                                                path: `AddressDetails.${index}.Address.Address1`,
                                            },
                                            {
                                                value: null,
                                                path: `AddressDetails.${index}.Address.Address2`,
                                            },
                                            {
                                                value: null,
                                                path: `AddressDetails.${index}.Address.Address3`,
                                            },
                                            {
                                                value: v,
                                                path: `AddressDetails.${index}.Address.Country`,
                                            },
                                            {
                                                value: null,
                                                path: `AddressDetails.${index}.Address.PostCode`,
                                            },
                                        ]);
                                        this.setState({ isEditManual: false });
                                    }}
                                    required={"Please select country"}
                                    selected={address?.Address?.Country ?? CountryCode.GBR}
                                />
                            </div>
                        </div>
                    </>
                )}

                <div className="row">
                    <div className="col-fluid col-max-430">
                        <PostCodeAnywhereSearchEditor
                            cssWrapper="control-size-430 mb-8"
                            subLabelId="Hint1"
                            onLookupError={() => {}}
                            useLabelForAddress
                            onAddressSelected={(v) => {
                                onCCMChange([
                                    {
                                        value: this.props.addressType,
                                        path: `AddressDetails.${index}.PhysicalAddressType`,
                                    },
                                    {
                                        value: v.Line1,
                                        path: `AddressDetails.${index}.Address.Address1`,
                                    },
                                    {
                                        value: v.Line2,
                                        path: `AddressDetails.${index}.Address.Address2`,
                                    },
                                    {
                                        value: v.Line3,
                                        path: `AddressDetails.${index}.Address.Address3`,
                                    },
                                    {
                                        value: v.CountryCode,
                                        path: `AddressDetails.${index}.Address.Country`,
                                    },
                                    {
                                        value: v.Postcode,
                                        path: `AddressDetails.${index}.Address.PostCode`,
                                    },
                                ]);
                                this.setState({ isEditManual: false });
                                if (resetUseAddressForCorrespondence != null) {resetUseAddressForCorrespondence();}
                            }}
                            countryCode={
                                !this.props.canChooseCountry
                                    ? CountryCode.GBR
                                    : address?.Address?.Country ?? CountryCode.GBR
                            }
                            label={this.props.label}
                        />
                        <p id="Hint1" className="text-size-14 mb-24">
                            PO boxes / 'care of' / financial adviser addresses can't be used
                        </p>
                    </div>
                    <div className="col-auto pt-38">
                        {this.state.isEditManual ? null : (
                            <button
                                className="add-button"
                                onClick={() => {
                                    this.setState({ isEditManual: true });
                                }}
                            >
                                <span className="icon" aria-hidden="true" />
                                <span className="text">Or enter address manually</span>
                            </button>
                        )}
                    </div>
                </div>
                {this.state.isEditManual ? (
                    <div className="mb-24">
                        <AddressEditorFields
                            required={true}
                            index={index}
                            address={address}
                            onCCMChange={(changes) => {
                                onCCMChange(changes);
                            }}
                            country={
                                !this.props.canChooseCountry
                                    ? CountryCode.GBR
                                    : address?.Address?.Country ?? CountryCode.GBR
                            }
                            data={null}
                            onChange={() => {}}
                            addressType={this.props.addressType}
                            onRef={(ref) => this.appendChild(ref)}
                        />
                    </div>
                ) : (
                    <div className="mb-24">
                        <AddressDisplay address={address} />
                    </div>
                )}
            </>
        );
    }
}
